import nvSharedModelsModule from '../nv.shared.models.module';

angular.module(nvSharedModelsModule).factory('CachedObject', function(NvBaseModel, ObjectHash, UtilitiesService) {
  const CachedObject = NvBaseModel(
    // eslint-disable-line new-cap
    '/v1/cachedObjects/:id',
  );

  CachedObject.extend({});

  return CachedObject;
});
